import type { GlobalUsersAndGroupsResponseRow } from '@risksmart-app/drizzle/src/dto';
import type { GetGlobalUsersAndGroupsQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetGlobalUsersAndGroupsDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetGlobalUsersAndGroupsArgs = Record<string, never>;

export const useGetGlobalUsersAndGroups = createQueryHook<
  UseGetGlobalUsersAndGroupsArgs,
  GlobalUsersAndGroupsResponseRow,
  GetGlobalUsersAndGroupsQuery
>({
  trpcQueryOptions: (trpc) =>
    trpc.frontend.attestation.globalUsersAndGroups.queryOptions(),
  mapTrpcDataToGraphQL: (data) => ({
    globalUsers: {
      aggregate: { count: data.globalUsers.count },
      nodes: data.globalUsers.nodes,
    },
    userGroups: data.userGroups,
  }),
  graphqlDocument: GetGlobalUsersAndGroupsDocument,
});
